import React from 'react';
import { FederatedModule } from '@bfme-technology/spa';
import { getResolvedMfeProps } from '../Dashboard.utils';



import type { MonthlyCashFlowProps } from './MonthlyCashFlow.types';

export const MonthlyCashFlow: React.FC<MonthlyCashFlowProps> = ({ routesLoading = false, routes = [] }) => {
  if (routesLoading) {
    return (
      <section className="glass-panel p-5 md:p-6 flex flex-col gap-4 items-center justify-center min-h-[148px]">
        <div className="text-text-muted text-xs py-10 text-center">Loading Cash Flow...</div>
      </section>
    );
  }
  const route = routes.find((r) => r.key === 'mfe-expense-manager');
  if (!route) {
    return (
      <section className="glass-panel p-5 md:p-6 flex flex-col gap-4 items-center justify-center min-h-[148px]">
        <div className="text-red-500 text-xs py-10 text-center">Expense Manager MFE configuration not found.</div>
      </section>
    );
  }
  const resolved: any = getResolvedMfeProps(route);
  const { key, ...mfeProps } = resolved;
  return (
    <FederatedModule
      {...mfeProps}
      mfeType="federated"
      scope="mfe_expense_manager"
      module="./MonthlyCashFlow"
    />
  );
};

export default MonthlyCashFlow;
